import React from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import { toaster } from 'evergreen-ui';
import { isAdminSelector } from 'Services/auth.service';
import SoftwareAppVersion from './Software.AppVersion';

const Releases = React.lazy(() => import('./Software.Releases'));

export default function SettingsSoftwareRouter() {
  const isAdmin = useSelector(isAdminSelector);
  React.useEffect(() => {
    if (!isAdmin) toaster.warning('Нет прав для просмотра настроек!');
  }, [isAdmin]);

  if (!isAdmin) return <Navigate to="/" />;
  return (
    <Routes>
      <Route path="software-app-version" element={<SoftwareAppVersion />} />
      {/* <Route path="software-releases" element={<Releases />} /> */}
      <Route path="*" element={<Navigate to="software-app-version" replace />} />
    </Routes>
  );
}
